<div class="top-container">
  <h1>Vertical Talent Group</h1>
  <div class="splash-container">
    <div class="splash-item-left">
      <img alt="manager dashboard screenshot" class="page-media" src="home-tile-2.png">
    </div>
    <div class="splash-item-right">
      <div class="front-page-header">As creators scale, so do their needs.</div>
      <div class="front-page-text">Our comprehensive platform supports management firms by offering two solutions: full-service management of deal negotiations and market outreach, or cutting-edge technology to streamline your processes. This allows management firms to focus on their core strengths: advising creators, managing teams, and building new business.</div>
    </div>
  </div>
  <div class="center-button">
    <button routerLink="/contactus" class="transparent-button">Let's Chat! </button>
  </div>
</div>

<div class="bottom-container">
  <h1>Services</h1>
  <div class="tile-container">
    <div class="tile">
      <div><img class="tile-icon" src="/manager_t1.svg" alt="Icon" /></div>
      <div class="tile-header">Streamlined Processes</div>
      <div class="tile-body small-text">Our platform is a purpose-built project management tool for digital representatives, streamlining the entire deal process. We automate everything from deal intake to payment reconciliation, giving you faster results while spending less time on repetitive admin tasks.</div>
    </div>
    <div class="tile">
      <div><img class="tile-icon" src="/manager_t2.svg" alt="Icon" /></div>
      <div class="tile-header">Faster, Smarter Contracts</div>
      <div class="tile-body">Managing contracts doesn’t need to be a bottleneck. Our platform helps you process agreements faster and more cost-effectively, enabling quicker decisions and saving you significant time and money.</div>
    </div>
    <div class="tile">
      <div><img class="tile-icon" src="/manager_t3.svg" alt="Icon" /></div>
      <div class="tile-header">Know Who's Spending, Before They Spend</div>
      <div class="tile-body">Our AI tools take the guesswork out of outbound and casting, analyzing brand behavior to match creators with brands poised to spend. It’s outbound, redefined for efficiency and precision.</div>
    </div>
  </div>
</div>
